const _excluded = ["className", "tooltip", "intent", "disabled", "testId", "checked"],
  _excluded2 = ["customThumb", "wrapper"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Switch as MuiSwitch } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import colors from "../../foundations/colors.module.scss";
import { MinusSmall, CheckSmall } from "../../icons";
import { ConditionalWrapper } from "../ConditionalWrapper";
import { useIntentBehavior } from "../IntentBehavior";
import { Tooltip } from "../Tooltip";
import { jsx as _jsx } from "react/jsx-runtime";
const useStyles = makeStyles({
  root: {
    width: 48,
    height: 24,
    padding: 0
  },
  switchBase: {
    padding: 1,
    color: colors.white,
    '&$checked': {
      color: colors.white,
      transform: 'translateX(24px)',
      '& + $track': {
        backgroundColor: colors.buttonPrimary,
        opacity: 1,
        border: 'none'
      },
      '&:hover + $track': {
        backgroundColor: colors.buttonPrimaryDark
      },
      '& $customThumb': {
        color: colors.buttonPrimary
      },
      '&$disabled $customThumb': {
        color: colors.dark300
      },
      '&$disabled + $track': {
        backgroundColor: colors.dark300
      }
    },
    '&$disabled $customThumb': {
      color: colors.dark300
    },
    '&:hover + $track': {
      backgroundColor: colors.buttonDisabledDark
    },
    '&:hover $customThumb': {
      color: colors.buttonDisabledDark
    }
  },
  checked: {},
  disabled: {},
  track: {
    borderRadius: 90,
    backgroundColor: colors.buttonDisabled,
    opacity: 1
  },
  customThumb: {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: colors.white,
    color: colors.buttonDisabled,
    borderRadius: '50%'
  },
  wrapper: {
    display: 'inline-flex'
  }
});
export function Switch(props) {
  const {
      className,
      tooltip,
      intent,
      disabled,
      testId,
      checked
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const styles = useStyles();
  const {
      customThumb,
      wrapper: _wrapper
    } = styles,
    restStyles = _objectWithoutProperties(styles, _excluded2);
  const {
    getDisabled,
    getTooltip
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const tooltipFromIntent = intent ? getTooltip(intent) : null;
  const hasTooltip = !!(tooltip !== null && tooltip !== void 0 && tooltip.title) || !!tooltipFromIntent;
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: hasTooltip,
    wrapper: children => /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({}, tooltip || {
      placement: 'top',
      title: tooltipFromIntent
    }), {}, {
      children: /*#__PURE__*/_jsx("div", {
        className: cn(_wrapper, className),
        "data-testid": testId && "".concat(testId, "-wrapper"),
        children: children
      })
    })),
    children: /*#__PURE__*/_jsx(MuiSwitch, _objectSpread(_objectSpread({}, rest), {}, {
      checked: checked,
      "aria-checked": checked,
      disabled: disabledFromIntent || disabled,
      "data-testid": testId,
      className: cn(!hasTooltip && className),
      classes: restStyles,
      disableRipple: true,
      icon: /*#__PURE__*/_jsx("div", {
        className: customThumb,
        children: /*#__PURE__*/_jsx(MinusSmall, {})
      }),
      checkedIcon: /*#__PURE__*/_jsx("div", {
        className: customThumb,
        children: /*#__PURE__*/_jsx(CheckSmall, {})
      }),
      inputProps: _objectSpread({
        'data-testid': testId && "".concat(testId, "-input")
      }, rest.inputProps) // eslint-disable-line @typescript-eslint/no-explicit-any
    }))
  });
}